module.exports = __webpack_public_path__ + "static/media/camden-park.fe5ba95b.pdf";